import { jsx as e, jsxs as n } from "../../_virtual/jsx-runtime.mjs";
import * as r from "react";
import { reoButton as v, reoButtonNormal as y, reoButtonSize as k, reoButtonGhost as N, reoButtonDisabled as T, reoButtonLoading as M, reoButtonIconSize as z, reoButtonOnlyIconSize as P, reoButtonIconLeft as R, reoButtonIcon as x, loadingWrap as I, ghostLoadingBar as d, reoButtonContent as W, reoButtonWrap as w } from "./css/ReoButton.mjs";
import D from "../../depend/classnames/index.mjs";
import L from "../ReoIcon/ReoIcon.mjs";
import { getValByDef as c } from "../../utils/getValByDef.mjs";
import { baseButtonProps as O, defaultReoButtonProps as u } from "./const.mjs";
import { useOmitProps as S } from "../../hook/useOmitProps.mjs";
import "../ReoForm/context/FormItemInputContext.mjs";
import "../ReoForm/context/ReoFormCompContext.mjs";
import j from "../../Basic/LoadingBar/LoadingBar.mjs";
import { useTheme as E } from "../../hook/useTheme.mjs";
import { EThemeTemplate as V } from "../../common/type.mjs";
const q = r.forwardRef((o, m) => {
  const p = S(o, O), l = r.useMemo(
    () => c(o.size, u.size),
    [o.size]
  ), B = r.useMemo(
    () => c(o.htmlType, u.htmlType),
    [o.htmlType]
  ), a = E({ theme: o.theme, template: V.BUTTON }), h = r.useMemo(
    () => D(
      v,
      y,
      // 按钮尺寸
      k[l],
      // 是否为描边按钮
      o.ghost ? N : null,
      // 是否禁用
      o.disabled ? T : null,
      // loading
      o.loading ? M : null,
      // 是否带icon
      o.icon ? z[l] : null,
      // 是否为纯icon
      !o.children && o.icon ? P[l] : null,
      // icon在左边
      o.iconPosition === "left" ? R : null,
      o.className,
      a
    ),
    [
      o.children,
      o.className,
      o.disabled,
      o.ghost,
      o.icon,
      o.iconPosition,
      o.loading,
      l,
      a
    ]
  ), g = r.useMemo(
    () => ({
      "--color": o.color,
      "--border-color": o.borderColor,
      "--background-color": o.backgroundColor,
      "--active-color": o.activeColor,
      "--active-border-color": o.activeBorderColor,
      "--active-background-color": o.activeBackgroundColor,
      "--disabled-color": o.disabledColor,
      "--disabled-border-color": o.disabledBorderColor,
      "--disabled-background-color": o.disabledBackgroundColor,
      ...o.style
    }),
    [
      o.activeBackgroundColor,
      o.activeBorderColor,
      o.activeColor,
      o.backgroundColor,
      o.borderColor,
      o.color,
      o.disabledBackgroundColor,
      o.disabledBorderColor,
      o.disabledColor,
      o.style
    ]
  ), b = r.useCallback((s) => {
    var i;
    if (o.disabled || o.loading) {
      s.preventDefault();
      return;
    }
    (i = o.onClick) == null || i.call(o, s);
  }, [o]), C = r.useMemo(() => o.icon ? /* @__PURE__ */ e(
    "span",
    {
      style: {
        opacity: Number(!o.loading)
      },
      className: x,
      children: /* @__PURE__ */ e(
        L,
        {
          name: o.icon,
          width: "var(--icon-width)",
          color: "var(--icon-color)"
        }
      )
    }
  ) : null, [o.icon, o.loading]), t = r.useMemo(() => o.loading ? /* @__PURE__ */ e("div", { className: I, children: /* @__PURE__ */ e(
    j,
    {
      longBarWidth: "100%",
      shortBarWidth: "22%",
      longBarColor: o.ghost ? d.longBarColor : void 0,
      shortBarColor: o.ghost ? d.shortBarColor : void 0
    }
  ) }) : null, [o]), f = r.useMemo(() => o.children ? /* @__PURE__ */ n(
    "span",
    {
      className: W,
      children: [
        /* @__PURE__ */ e(
          "span",
          {
            style: {
              opacity: Number(!o.loading)
            },
            children: o.children
          }
        ),
        t
      ]
    }
  ) : null, [t, o.children, o.loading]);
  return /* @__PURE__ */ e(
    "button",
    {
      ref: m,
      type: B,
      className: h,
      onClick: b,
      style: g,
      ...p,
      children: /* @__PURE__ */ n(
        "div",
        {
          className: w,
          children: [
            f,
            C
          ]
        }
      )
    }
  );
});
q.displayName = "ReoButton";
export {
  q as default
};
//# sourceMappingURL=ReoButton.mjs.map
